<div class="container-fluid">
    <div class="image">
        <img
            alt="Sign Up Image"
            src="https://static.pbslearningmedia.org/defaults/signup_heading.png"
        />
    </div>
    <div class="container heading-wrapper">
        <div class="row no-gutters">
            <div class="content col-lg-12 col-xl-6">
                <div class="title-wrapper">
                    <h2 class="heading-title">
                        Sign up for a free account on PBS LearningMedia to unlock a range of
                        additional features.
                        <span class="your-account"> Your account enables you to: </span>
                    </h2>
                </div>
                <ul class="heading-description">
                    <li>Explore resources aligned to state standards</li>
                    <li>Save, download, and create content using your favorite resources</li>
                    <li>Access teacher tools to build lessons and differentiate instruction</li>
                    <li>Share content easily with Google Classroom and Schoology</li>
                </ul>
                <div class="secondary-description">
                    With thousands of lesson plans, games, and interactive resources, it’s never
                    been easier to find the content you need to amplify your lessons, kick-start
                    classroom conversations, and help spark students’ sense of curiosity.
                </div>
                <div class="brands">
                    <div class="pbs-logo">
                        <img
                            alt="PBS Logo"
                            src="https://static.pbslearningmedia.org/defaults/PBS-logo-white.svg"
                        />
                    </div>
                    <div class="wgbh-logo">
                        <img
                            alt="WGBH Image"
                            src="https://static.pbslearningmedia.org/defaults/wgbh_white.png"
                        />
                    </div>
                    <div class="pbs-kids-logo">
                        <img
                            alt="PBS Kids Logo"
                            src="https://static.pbslearningmedia.org/defaults/pbs_kids.png"
                        />
                    </div>
                </div>
            </div>
            <div class="col-lg-0 col-xl-1"></div>
            <div class="col-lg-12 col-xl-5">
                <app-auth-modal-content
                    [nextURL]="nextUrl"
                    [pbsEmailRegister]="true"
                    [registerDescription]="authSectionDescription"
                    [registerLinkText]="authSectionLinkText"
                    [title]="authSectionTitle"
                    class="auth-section"
                ></app-auth-modal-content>
            </div>
        </div>
    </div>
</div>
<div class="container marketing-wrapper">
    <app-marketing-description
        [marketingImage]="
            'https://static.pbslearningmedia.org/defaults/students-raising-hands-in-classroom-with-teacher.jpg'
        "
    >
        <h2 class="title">Bring the world to your classroom</h2>
        <p class="description">
            We know how hard you work to support your students. You are their mentor, guide, and
            champion, helping them develop life’s most important skills. And you know better than
            anyone else how to prepare them for the road ahead. That’s why PBS and WGBH partnered to
            create PBS LearningMedia, a trusted source for PreK-12 classroom resources. We offer
            free and easy access to thousands of lesson plans, videos, interactives, and curated
            content collections to help you create one-of-a kind learning experiences for your
            students.
        </p>
    </app-marketing-description>
    <app-marketing-description
        [imageSide]="'left'"
        [marketingImage]="
            'https://static.pbslearningmedia.org/defaults/pbs-classroom-ready-resources.jpg'
        "
    >
        <h2 class="title">Uncover award-winning content</h2>
        <p class="description">
            Make the most of the school day and spend less time searching for materials! We’ve
            curated a wide range of classroom-ready resources, including standards-aligned content
            from PBS, your local PBS station, and trusted educational partners like the Library of
            Congress and the Smithsonian. With just a few clicks, you can access firsthand accounts
            from veterans, footage from the depths of the ocean, science lessons from space,
            historical letters and photographs, and multimedia lesson plans perfect for helping
            students form deeper, more meaningful connections to the curriculum. Here are a few of
            our favorite collections:
        </p>
        <ul>
            <li>
                <a routerLink="/collection/ken-burns-teaching/"
                    >Ken Burns: Teaching American History and Culture</a
                >
            </li>
            <li>
                <a routerLink="/collection/physics-girl/">Physics Girl</a>
            </li>
            <li>
                <a routerLink="/collection/crash-course/">Crash Course</a>
            </li>
            <li>
                <a routerLink="/collection/marchonwashington/">The March on Washington</a>
            </li>
            <li>
                <a routerLink="/collection/shakespeare-uncovered/">Shakespeare Uncovered</a>
            </li>
            <li>
                <a routerLink="/collection/nova/">NOVA</a>
            </li>
        </ul>
    </app-marketing-description>
    <app-marketing-description
        [marketingImage]="
            'https://static.pbslearningmedia.org/defaults/pbs-kids-in-the-classroom.jpg'
        "
    >
        <h2 class="title">Inspire your youngest learners</h2>
        <p class="description">
            PBS KIDS applies a whole-child approach to media content, supporting all of the key
            developmental areas an early learner needs to be successful in school - and life. We
            work extensively with early childhood education experts, advisors, classroom
            practitioners and producers to create developmentally-appropriate educational content.
            You’ll find free videos, games, worksheets, printables, activity guides, and more
            featuring beloved characters and engaging, child-friendly resources. Explore a few of
            our collections:
        </p>
        <ul>
            <li>
                <a routerLink="/collection/daniel-tigers-neighborhood/"
                    >Daniel Tiger’s Neighborhood</a
                >
            </li>
            <li>
                <a routerLink="/collection/wild-kratts/">Wild Kratts</a>
            </li>
            <li>
                <a routerLink="/collection/super-why/">SUPER WHY!</a>
            </li>
            <li>
                <a routerLink="/collection/odd-squad/">Odd Squad</a>
            </li>
            <li>
                <a routerLink="/collection/sesame_street/">Sesame Street</a>
            </li>
            <li>
                <a routerLink="/collection/curiousgeorge/">Curious George STEM</a>
            </li>
        </ul>
    </app-marketing-description>
    <app-marketing-description
        [imageSide]="'left'"
        [marketingImage]="
            'https://static.pbslearningmedia.org/defaults/teacher-and-excited-student-engaging-in-classroom.jpg'
        "
    >
        <h2 class="title">Teacher-friendly features</h2>
        <p class="description">
            Too many passwords? We hear you. PBS LearningMedia is now compatible with the tools you
            use most, like Google Classroom, Schoology, and Clever.
        </p>
        <ul>
            <li>
                GOOGLE CLASSROOM: Import your class roster directly to PBS LearningMedia - creating
                a seamless experience between both services
            </li>
            <li>
                REMIND: Share your favorite PBS LearningMedia resources using the Remind text
                messaging service
            </li>
            <li>
                SCHOOLOGY: Adding PBS LearningMedia to your school’s Schoology account through the
                App Center enables instant single-sign-on integration, so you can sign on with your
                existing Schoology account.
            </li>
            <li>
                CLEVER: Already using Clever? You can sign in to PBS LearningMedia using your Clever
                log-in.
            </li>
        </ul>
    </app-marketing-description>
</div>
<div class="container-fluid testimonials-section">
    <div class="container">
        <div class="testimonials-wrapper">
            <h2 class="title">What Teachers Are Saying</h2>
            <h5 class="description">
                From St. Louis, MO to Durham, NC - educators across the country are praising PBS
                LearningMedia for its trusted, high-quality content, user-friendly interface, and
                its ability to engage students in the classroom. Here’s what they have to say.
            </h5>
            <div class="row row-eq-height no-gutters">
                <div class="col-lg-12 col-xl-4 testimonial">
                    <app-testimonial>
                        <div class="name">Mallory Mbalia</div>
                        <div class="profession">Kindergarten, Wake County, NC</div>
                        <div class="opinion">
                            "PBS LearningMedia empowers students to explore independently, at their
                            own pace which helps build their confidence and desire to succeed."
                        </div>
                    </app-testimonial>
                </div>
                <div class="col-lg-12 col-xl-4 testimonial">
                    <app-testimonial>
                        <div class="name">Don Goble</div>
                        <div class="profession">
                            Broadcast Technology, Film & Multimedia Instructor, St. Louis, MO
                        </div>
                        <div class="opinion">
                            "As teachers, we are constantly bombarded with new tools, new devices,
                            and new apps. Finding trustworthy resources can be daunting so having a
                            resource like PBS LearningMedia is very valuable."
                        </div>
                    </app-testimonial>
                </div>
                <div class="col-lg-12 col-xl-4 testimonial">
                    <app-testimonial>
                        <div class="name">Mig Hayes</div>
                        <div class="profession">
                            6th-12th Grade Teacher & Media Specialist, Durham, NC
                        </div>
                        <div class="opinion">
                            "...your challenge as a teacher is to serve a range of students - from
                            the most accelerated to those struggling to succeed. By having tools
                            like PBS LearningMedia, I can give my students a video to view at night
                            and by the time they come back to school, they will have had time to
                            digest the information on their own."
                        </div>
                    </app-testimonial>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container">
    <div class="call-to-action-wrapper">
        <h5 class="title">
            Ready to inspire your students with thousands of high-quality, trusted resources?
        </h5>
        <app-button (click)="scrollToTop()" class="call-to-action-button">
            Create an Account Now
        </app-button>
    </div>
</div>
